import { joinCn } from '../util';

export const style = {
  languageSwitch(visible: boolean) {
    return joinCn(
      'h-10 w-fit rounded-md px-2 py-1 text-body-m font-bold',
      'hover:shadow-sm',
      {
        'bg-white text-black': !visible,
        'bg-tertiary-200 text-secondary-300': visible,
      },
    );
  },

  icon: 'size-4',
};
